import React from 'react'

// Types
import { LinkProps } from '../types'

// Containers
import { NavigationConsumer } from '../context'

@NavigationConsumer()
export default class Link extends React.Component<LinkProps> {

  handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()
    const { route, navigation } = this.props
    const { actions } = navigation

    actions.navigate(route)
  }

  render() {
    let props = { ...this.props }
    delete props.navigation
    delete props.route

    return (
      <a
        onClick={this.handleClick}
        href={this.props.route}
        {...props}
      />
    )
  }

}
